import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const TodokedeRikuunKbn = props => {
  return <Dropdown.Static kubunKey='todokede_rikuun_kbn' {...props} />
}
